/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2uo31fVZWJ%7Bbackground%3Avar(--avatar-bg-color)%7D%0A._24h04iPvdi%7Bbox-sizing%3Acontent-box%7D%0A._2OUyjtrcoi%7Bbox-shadow%3Avar(--avatar-box-shadow)%7D%0A._4c065U9E27%7Bpadding-block%3Acalc(var(--ds-border-width-selected%2C%202px)*1.25)%7D%0A._2Y7lL42M4S%7Bpadding-inline%3Avar(--ds-border-width-selected%2C2px)%7D%0A._3SamIHoYZL%7Bmargin-block%3Acalc(var(--ds-border-width-selected%2C%202px)*1.25*-1)%7D%0A._2YLqiKnBff%7Bmargin-inline%3Acalc(var(--ds-border-width-selected%2C%202px)*-1)%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._1uo2ZfTcEg%7Bclip-path%3Apolygon(45%25%201.33975%25%2C46.5798%25%20.60307%25%2C48.26352%25%20.15192%25%2C50%25%200%2C51.73648%25%20.15192%25%2C53.4202%25%20.60307%25%2C55%25%201.33975%25%2C89.64102%25%2021.33975%25%2C91.06889%25%2022.33956%25%2C92.30146%25%2023.57212%25%2C93.30127%25%2025%25%2C94.03794%25%2026.5798%25%2C94.48909%25%2028.26352%25%2C94.64102%25%2030%25%2C94.64102%25%2070%25%2C94.48909%25%2071.73648%25%2C94.03794%25%2073.4202%25%2C93.30127%25%2075%25%2C92.30146%25%2076.42788%25%2C91.06889%25%2077.66044%25%2C89.64102%25%2078.66025%25%2C55%25%2098.66025%25%2C53.4202%25%2099.39693%25%2C51.73648%25%2099.84808%25%2C50%25%20100%25%2C48.26352%25%2099.84808%25%2C46.5798%25%2099.39693%25%2C45%25%2098.66025%25%2C10.35898%25%2078.66025%25%2C8.93111%25%2077.66044%25%2C7.69854%25%2076.42788%25%2C6.69873%25%2075%25%2C5.96206%25%2073.4202%25%2C5.51091%25%2071.73648%25%2C5.35898%25%2070%25%2C5.35898%25%2030%25%2C5.51091%25%2028.26352%25%2C5.96206%25%2026.5798%25%2C6.69873%25%2025%25%2C7.69854%25%2023.57212%25%2C8.93111%25%2022.33956%25%2C10.35898%25%2021.33975%25)%7D%0A._3YCJEinXvL%3Ahas(%3Afocus-visible)%7Bbackground-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._1uo2ZfEXe0%7Bclip-path%3Apolygon(43.61555%25%201.47441%25%2C46.08136%25%20.49147%25%2C48.6791%25%200%2C51.3208%25%200%2C53.91847%25%20.49147%25%2C56.38412%25%201.47441%25%2C93.61555%25%2020.77327%25%2C95.79666%25%2022.19894%25%2C97.56964%25%2023.97299%25%2C98.89052%25%2026.02699%25%2C99.7153%25%2028.29251%25%2C100%25%2030.70112%25%2C100%25%2069.29883%25%2C99.7153%25%2071.70746%25%2C98.89052%25%2073.973%25%2C97.56964%25%2076.027%25%2C95.79666%25%2077.801%25%2C93.61555%25%2079.22654%25%2C56.38412%25%2098.5254%25%2C53.91847%25%2099.50837%25%2C51.3208%25%2099.99991%25%2C48.6791%25%20100%25%2C46.08136%25%2099.5086%25%2C43.61555%25%2098.52569%25%2C6.38428%25%2079.22654%25%2C4.20328%25%2077.801%25%2C2.43035%25%2076.027%25%2C1.10949%25%2073.973%25%2C.28471%25%2071.70746%25%2C0%2069.29883%25%2C0%2030.70112%25%2C.28471%25%2028.29251%25%2C1.10949%25%2026.02699%25%2C2.43035%25%2023.97299%25%2C4.20328%25%2022.19894%25%2C6.38428%25%2020.77327%25)%7D%0A._4c065U7oRc%7Bpadding-block%3Acalc(var(--ds-border-width-selected%2C%202px)*.5)%7D%0A._2Y7lL4Aa7o%7Bpadding-inline%3Acalc(var(--ds-border-width-selected%2C%202px)*.4)%7D%0A._3SamIHzX4W%7Bmargin-block%3Acalc(var(--ds-border-width-selected%2C%202px)*.5*-1)%7D%0A._2YLqiKTz7d%7Bmargin-inline%3Acalc(var(--ds-border-width-selected%2C%202px)*.4*-1)%7D%0A._1uo2ZfOLYo%7Bclip-path%3Ainherit%7D%0A._3YCJEilfZc%3Ahas(%3Afocus-visible)%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._0bjKvDdnbC%7Bborder-radius%3A0%7D%0A._2OUyjtZqHV%7Bbox-shadow%3Aunset%7D%0A._2Gfj6idnbC%3Aafter%7Bborder-radius%3A0%7D%0A._3kPd40ZqHV%3Afocus-visible%7Bbox-shadow%3Aunset%7D%0A._2wtOC9dnbC%3Afocus-visible%7Boutline-width%3A0%7D%0A%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._0hSAgbdnbC%3Afocus-visible%7Boutline-width%3A0%7D%7D%0A._0wOv4Q7zJH%7Bcursor%3Apointer%7D%0A._0jKh9gMC01%3Ahover%3Aafter%7Bbackground-color%3Avar(--ds-interaction-hovered%2C%2300000029)%7D%0A._0ZgYXI7dHp%3Ahover%3Aafter%7Bopacity%3A1%7D%0A._14Uf36qui9%3Aactive%3Aafter%7Bbackground-color%3Avar(--ds-interaction-pressed%2C%2300000052)%7D%0A._0WVYA37dHp%3Aactive%3Aafter%7Bopacity%3A1%7D%0A%40media%20screen%20and%20(forced-colors%3Aactive)%7B._1if2KaHZdu%3Afocus-visible%7Boutline-width%3A1px%7D%7D%0A._23rrnHimX9%7Btransition%3Avar(--ds-avatar-hovered%2Ctransform%20.25s%20linear(0%2C.021%2C.058%2C.107%2C.164%2C.227%2C.292%2C.359%2C.425%2C.49%2C.552%2C.61%2C.664%2C.714%2C.759%2C.8%2C.837%2C.869%2C.898%2C.922%2C.943%2C.961%2C.976%2C.988%2C.998%2C1.006%2C1.013%2C1.017%2C1.02%2C1.023%2C1.024%2C1.024%2C1.024%2C1.024%2C1.023%2C1.022%2C1.02%2C1.019%2C1.017%2C1.015%2C1.014%2C1.012%2C1.011%2C1.009%2C1.008%2C1.007%2C1.006%2C1.005%2C1.004%2C1.003%2C1.002%2C1.002%2C1.001%2C1.001%2C1.001%2C1%2C1%2C1%2C1%2C1%2C.999%2C.999%2C.999%2C.999%2C1))%7D%0A._1sLQ8qC67X%7Bwill-change%3Atransform%7D%0A._3NJLv82rpu%3Ahover%7Btransform%3Ascale(1.12)%7D%0A._30huDKYbGa%7Bborder%3Anone%7D%0A._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D%0A._497WNwYbGa%7Boutline-style%3Anone%7D%0A._2zndICT6kp%7Boutline-width%3Amedium%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xd5HSx%7Bposition%3Astatic%7D%0A._0hPCNLFlnN%7Balign-items%3Astretch%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._0wOv4QOLYo%7Bcursor%3Ainherit%7D%0A._0rIjykFQfX%7Bmargin-block-end%3Avar(--ds-space-025%2C2px)%7D%0A._43nrzTFQfX%7Bmargin-block-start%3Avar(--ds-space-025%2C2px)%7D%0A._2xTnZxFQfX%7Bmargin-inline-end%3Avar(--ds-space-025%2C2px)%7D%0A._0GTcwRFQfX%7Bmargin-inline-start%3Avar(--ds-space-025%2C2px)%7D%0A._0xmtkoPgdg%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D%0A._46hvQmPgdg%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D%0A._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._0EnhYgPgdg%3Aafter%7Binset%3Avar(--ds-space-0%2C0)%7D%0A._1JM8vv4Jcb%3Aafter%7Btransition%3Aopacity%20.2s%7D%0A._2jfUf9N91d%3Aafter%7Bwidth%3A100%25%7D%0A._2WYcYGWVPG%3Aafter%7Bposition%3Aabsolute%7D%0A._3wEj0XjOvk%3Aafter%7Bbackground-color%3Atransparent%7D%0A._0GBAIrJ5bs%3Aafter%7Bcontent%3A%22%20%22%7D%0A._43i6GSdnbC%3Aafter%7Bopacity%3A0%7D%0A._2tbAUcYbGa%3Aafter%7Bpointer-events%3Anone%7D%0A._3kPd40YbGa%3Afocus-visible%7Bbox-shadow%3Anone%7D%0A._1ubuxonXvL%3Afocus-visible%7Boutline-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._34b3D2FQfX%3Afocus-visible%7Boutline-offset%3Avar(--ds-space-025%2C2px)%7D%0A._1NDpvb6wH8%3Afocus-visible%7Boutline-style%3Asolid%7D%0A._2wtOC9vc3e%3Afocus-visible%7Boutline-width%3Avar(--ds-border-width-focused%2C2px)%7D%0A%40media%20screen%20and%20(-ms-high-contrast%3Aactive)%2Cscreen%20and%20(forced-colors%3Aactive)%7B._0hSAgbNvrM%3Afocus-visible%7Boutline-width%3Avar(--ds-border-width%2C1px)%7D%7D%0A._0bjKvDaaQb%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D%0A._2Gfj6iaaQb%3Aafter%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D%0A._0bjKvD0O7w%7Bborder-radius%3Avar(--ds-radius-tile%2C25%25)%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._2YgrGrP0S5%7Bisolation%3Aisolate%7D%0A._23rrnHiNRm%7Btransition%3Atransform%20.2s%2Copacity%20.2s%7D%0A._1VJPcaeKTE%7Btransform%3AtranslateZ(0)%7D%0A._0wOv4Qsyl5%7Bcursor%3Anot-allowed%7D%0A._3wEj0XlfZc%3Aafter%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._43i6GSVx3j%3Aafter%7Bopacity%3Avar(--ds-opacity-disabled%2C.4)%7D%0A._39xV02ey7F%7Bwidth%3A1pc%7D%0A._0jFU0Vey7F%7Bheight%3A1pc%7D%0A._39xV02SPN1%7Bwidth%3A20px%7D%0A._0jFU0VSPN1%7Bheight%3A20px%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._39xV02Uofl%7Bwidth%3A2pc%7D%0A._0jFU0VUofl%7Bheight%3A2pc%7D%0A._39xV02UF4f%7Bwidth%3A40px%7D%0A._0jFU0VUF4f%7Bheight%3A40px%7D%0A._39xV02JgOI%7Bwidth%3A6pc%7D%0A._0jFU0VJgOI%7Bheight%3A6pc%7D%0A._39xV02NNui%7Bwidth%3A8pc%7D%0A._0jFU0VNNui%7Bheight%3A8pc%7D%0A._39xV02EGCh%7Bwidth%3A15.4px%7D%0A._0jFU0VQSd4%7Bheight%3A17.17px%7D%0A._39xV021R6D%7Bwidth%3A23.11px%7D%0A._0jFU0V7qhK%7Bheight%3A1.61pc%7D%0A._39xV02U2XU%7Bwidth%3A30.81px%7D%0A._0jFU0VRlO4%7Bheight%3A34.34px%7D%0A._39xV02s3iu%7Bwidth%3A38.51px%7D%0A._0jFU0VNmyB%7Bheight%3A42.93px%7D%0A._39xV02OhVQ%7Bwidth%3A92.44px%7D%0A._0jFU0VHWFU%7Bheight%3A6.44pc%7D%0A._39xV02c73x%7Bwidth%3A123.25px%7D%0A._0jFU0VSk01%7Bheight%3A137.39px%7D%0A._0xmtkofkS7%7Bpadding-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*.125)%7D%0A._46hvQmfkS7%7Bpadding-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*.125)%7D%0A._03SyCPdnbC%7Bpadding-inline-end%3A0%7D%0A._0LQT5EdnbC%7Bpadding-inline-start%3A0%7D%0A._0rIjyk5hfz%7Bmargin-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-.125)%7D%0A._43nrzT5hfz%7Bmargin-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-.125)%7D%0A._2xTnZxdnbC%7Bmargin-inline-end%3A0%7D%0A._0GTcwRdnbC%7Bmargin-inline-start%3A0%7D%0A._0xmtkoQVeh%7Bpadding-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*1.125)%7D%0A._46hvQmQVeh%7Bpadding-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*1.125)%7D%0A._03SyCP2M4S%7Bpadding-inline-end%3Avar(--ds-border-width-selected%2C2px)%7D%0A._0LQT5E2M4S%7Bpadding-inline-start%3Avar(--ds-border-width-selected%2C2px)%7D%0A._0rIjyk59JZ%7Bmargin-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.125)%7D%0A._43nrzT59JZ%7Bmargin-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.125)%7D%0A._2xTnZxnBff%7Bmargin-inline-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-1)%7D%0A._0GTcwRnBff%7Bmargin-inline-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-1)%7D%0A._0xmtkoUduD%7Bpadding-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*.12)%7D%0A._46hvQmUduD%7Bpadding-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*.12)%7D%0A._03SyCPUduD%7Bpadding-inline-end%3Acalc(var(--ds-border-width-selected%2C%202px)*.12)%7D%0A._0LQT5EUduD%7Bpadding-inline-start%3Acalc(var(--ds-border-width-selected%2C%202px)*.12)%7D%0A._0rIjykPM89%7Bmargin-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-.12)%7D%0A._43nrzTPM89%7Bmargin-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-.12)%7D%0A._2xTnZxPM89%7Bmargin-inline-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-.12)%7D%0A._0GTcwRPM89%7Bmargin-inline-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-.12)%7D%0A._0xmtko7SV6%7Bpadding-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*1.12)%7D%0A._46hvQm7SV6%7Bpadding-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*1.12)%7D%0A._03SyCP7SV6%7Bpadding-inline-end%3Acalc(var(--ds-border-width-selected%2C%202px)*1.12)%7D%0A._0LQT5E7SV6%7Bpadding-inline-start%3Acalc(var(--ds-border-width-selected%2C%202px)*1.12)%7D%0A._0rIjykAoU6%7Bmargin-block-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.12)%7D%0A._43nrzTAoU6%7Bmargin-block-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.12)%7D%0A._2xTnZxAoU6%7Bmargin-inline-end%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.12)%7D%0A._0GTcwRAoU6%7Bmargin-inline-start%3Acalc(var(--ds-border-width-selected%2C%202px)*-1.12)%7D");





































































































































import { type CSSProperties, forwardRef, type ReactNode, useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { AvatarContentContext } from './internal/content-context';
import { useEnsureIsInsideAvatar } from './internal/use-ensure-is-inside-avatar';
const boxShadowCssVar = '--avatar-box-shadow';
const bgColorCssVar = '--avatar-bg-color';
const styles = {
  root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XjOvk _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa _3kPd40YbGa _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _0hSAgbNvrM",
  circle: "_0bjKvDaaQb _2Gfj6iaaQb",
  square: "_0bjKvD0O7w",
  positionRelative: "_1mT5xdRAKS",
  isolation: "_1mT5xdRAKS _2YgrGrP0S5",
  legacyLayerPromotion: "_23rrnHiNRm _1VJPcaeKTE",
  disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const unboundStyles = {
  root: "_2uo31fVZWJ _24h04iPvdi _2OUyjtrcoi",
  hexagonFocusContainer: "_4c065U9E27 _2Y7lL42M4S _3SamIHoYZL _2YLqiKnBff _0KLXrujOvk _1uo2ZfTcEg _3YCJEinXvL",
  updatedHexagonClipPath: "_1uo2ZfEXe0",
  hexagonBorderContainer: "_2uo31fVZWJ _4c065U7oRc _2Y7lL4Aa7o _3SamIHzX4W _2YLqiKTz7d _1uo2ZfOLYo _3YCJEilfZc",
  hexagon: "_0bjKvDdnbC _1uo2ZfOLYo _2OUyjtZqHV _2Gfj6idnbC _3kPd40ZqHV _2wtOC9dnbC _0hSAgbdnbC",
  interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu",
  interactiveMotion: "_23rrnHimX9 _1sLQ8qC67X _3NJLv82rpu"
};
const hexagonBorderFixStyles = {
  hexagonBorderContainer: "_0xmtkoUduD _46hvQmUduD _03SyCPUduD _0LQT5EUduD _0rIjykPM89 _43nrzTPM89 _2xTnZxPM89 _0GTcwRPM89",
  hexagonFocusContainer: "_0xmtko7SV6 _46hvQm7SV6 _03SyCP7SV6 _0LQT5E7SV6 _0rIjykAoU6 _43nrzTAoU6 _2xTnZxAoU6 _0GTcwRAoU6"
};

// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const updatedHexagonBorderFixStyles = {
  hexagonBorderContainer: "_0xmtkofkS7 _46hvQmfkS7 _03SyCPdnbC _0LQT5EdnbC _0rIjyk5hfz _43nrzT5hfz _2xTnZxdnbC _0GTcwRdnbC",
  hexagonFocusContainer: "_0xmtkoQVeh _46hvQmQVeh _03SyCP2M4S _0LQT5E2M4S _0rIjyk59JZ _43nrzT59JZ _2xTnZxnBff _0GTcwRnBff"
};
const widthHeightMap = {
  xxsmall: "_39xV02ey7F _0jFU0Vey7F",
  xsmall: "_39xV02ey7F _0jFU0Vey7F",
  UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
  small: "_39xV02oWWg _0jFU0VoWWg",
  medium: "_39xV02Uofl _0jFU0VUofl",
  large: "_39xV02UF4f _0jFU0VUF4f",
  xlarge: "_39xV02JgOI _0jFU0VJgOI",
  xxlarge: "_39xV02NNui _0jFU0VNNui"
};

// The sole source of truth for the updated hexagon width/height geometry (per size).
const updatedHexagonDimensionMap = {
  xxsmall: "_39xV02EGCh _0jFU0VQSd4",
  small: "_39xV021R6D _0jFU0V7qhK",
  medium: "_39xV02U2XU _0jFU0VRlO4",
  large: "_39xV02s3iu _0jFU0VNmyB",
  xlarge: "_39xV02OhVQ _0jFU0VHWFU",
  xxlarge: "_39xV02c73x _0jFU0VSk01"
};
type AvatarContentProps = {
  children?: ReactNode;
};

/**
 * __Avatar content__
 *
 * Avatar content renders the avatar content. It can be composed with the Avatar component
 * to create a custom avatar.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */
export const AvatarContent: React.ForwardRefExoticComponent<React.PropsWithoutRef<AvatarContentProps> & React.RefAttributes<HTMLElement>> = forwardRef<HTMLElement, AvatarContentProps>(({
  children
}, ref) => {
  useEnsureIsInsideAvatar();
  const {
    as: Container,
    appearance,
    UNSAFE_isUpdatedGeometry,
    avatarImage,
    borderColor = "var(--ds-surface, #FFFFFF)",
    href,
    isDisabled,
    label,
    onClick,
    ref: contextRef,
    tabIndex,
    target,
    testId,
    size,
    stackIndex,
    'aria-controls': ariaControls,
    'aria-expanded': ariaExpanded,
    'aria-haspopup': ariaHasPopup
  } = useContext(AvatarContentContext);
  const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
  const renderedContent = <Container style={({
    [bgColorCssVar]: borderColor,
    [boxShadowCssVar]: `0 0 0 2px ${borderColor}`
  } as CSSProperties)} ref={((ref || contextRef) as React.Ref<HTMLAnchorElement & HTMLButtonElement & HTMLSpanElement>)} aria-label={isInteractive ? label : undefined} aria-controls={ariaControls} aria-expanded={ariaExpanded} aria-haspopup={ariaHasPopup} onClick={onClick} tabIndex={tabIndex} data-testid={testId} disabled={isDisabled} type={Container === 'button' ? 'button' : undefined} {...href && {
    href,
    target,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined
  }} className={ax([unboundStyles.root, styles.root, fg('platform_avatar_disable_layer_promotion') ? styles.isolation : styles.legacyLayerPromotion, appearance === 'square' && styles.square, appearance === 'circle' && styles.circle, appearance === 'hexagon' && unboundStyles.hexagon, widthHeightMap[size], UNSAFE_isUpdatedGeometry && updatedHexagonDimensionMap[(size as 'xxsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge')], stackIndex !== undefined && styles.positionRelative, isInteractive && !isDisabled && unboundStyles.interactive, isInteractive && !isDisabled && appearance !== 'hexagon' && fg('platform-dst-motion-uplift') && unboundStyles.interactiveMotion, isDisabled && styles.disabled])}>
			{children || avatarImage}
		</Container>;
  if (appearance !== 'hexagon') {
    return renderedContent;
  }

  // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
  // layer multiple elements and use their background colors to create the different layers.
  return <div style={({
    [bgColorCssVar]: borderColor,
    [boxShadowCssVar]: `0 0 0 2px ${borderColor}`
  } as CSSProperties)} data-testid={testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container'} className={ax([unboundStyles.hexagonFocusContainer, UNSAFE_isUpdatedGeometry && unboundStyles.updatedHexagonClipPath, isInteractive && !isDisabled && fg('platform-dst-motion-uplift') && unboundStyles.interactiveMotion, UNSAFE_isUpdatedGeometry && updatedHexagonBorderFixStyles.hexagonFocusContainer, fg('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && hexagonBorderFixStyles.hexagonFocusContainer])}>
			<div data-testid={testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container'} className={ax([unboundStyles.hexagonBorderContainer, UNSAFE_isUpdatedGeometry && updatedHexagonBorderFixStyles.hexagonBorderContainer, fg('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && hexagonBorderFixStyles.hexagonBorderContainer])}>
				{renderedContent}
			</div>
		</div>;
});